import { useCallback, useState } from "react";

type SuccessState = {
  open: boolean;
  title: string;
  onClose: () => void;
};

export const useSuccessDialog = () => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [afterClose, setAfterClose] = useState<null | (() => void)>(null);

  const showSuccess = useCallback((message: string, cb?: () => void) => {
    setTitle(message);
    setAfterClose(() => cb ?? null);
    setOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setOpen(false);
    afterClose?.();
    setAfterClose(null);
  }, [afterClose]);

  const dialogProps: SuccessState = { open, title, onClose };

  return { showSuccess, dialogProps };
};